interface Message<T = any> {
	payload: {
		event: string
		payload: T
	}
	source: string
}

type MessagePayload<T = any> = Message<T>['payload']

const shouldPostToIframeParent = () =>
	window.opener == null && window.location !== window.parent.location

class MessagingService {
	public dispatch = (payload: MessagePayload) => {
		const message: Message = {
			payload,
			source: 'smartcheck-flow-orchestrator-client-app',
		}
		this.postMessage(message)
	}

	private postMessage = (message: Message) => {
		if (shouldPostToIframeParent()) {
			window.parent?.postMessage?.(message, '*')
			return
		}

		window.opener?.postMessage?.(message, '*')
	}
}

export const messagingService = new MessagingService()
